var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.603,
    height: 32,
    viewBox: "0 0 32.603 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-box",
    transform: "translate(-785 -170)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon-box-2",
    "data-name": "icon-box",
    d: "M43.008,32.82,39,26.591c-.008-.013-.019-.022-.027-.034a.422.422,0,0,0-.206-.181L27.257,21.9a.381.381,0,0,0-.268,0L15.477,26.376a.434.434,0,0,0-.236.251l-4.075,6.189a.513.513,0,0,0-.063.412.438.438,0,0,0,.259.3L15.2,35.021V42.93a.463.463,0,0,0,.276.437l11.512,4.479s0,0,.006,0a.339.339,0,0,0,.257,0,.009.009,0,0,0,.006,0l11.512-4.479a.464.464,0,0,0,.278-.437V34.992l3.763-1.464a.441.441,0,0,0,.257-.3.509.509,0,0,0-.058-.41ZM27.121,22.826l10.822,4.208-2.732,1.1L27.178,31.26l-5.542-2.11-5.385-2.1ZM15.5,27.781a.369.369,0,0,0,.059.029l11.013,4.2-3.413,5.132-11-4.281Zm.519,7.559,7.155,2.784a.389.389,0,0,0,.135.025.4.4,0,0,0,.329-.186l3.069-4.616V46.761L16.019,42.6ZM27.532,46.761V33.085l2.989,4.865a.4.4,0,0,0,.339.2.38.38,0,0,0,.133-.025l7.229-2.813V42.6Zm3.488-9.626L27.9,32.063l10.7-4.311A.423.423,0,0,0,38.7,27.7l3.318,5.162Z",
    transform: "translate(774.415 151.627)",
    stroke: "#151515",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-icon",
    width: 32,
    height: 32,
    transform: "translate(785 170)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.b43c5a06911e29d88f46d05ded46ec9f.svg";
export { ForwardRef as ReactComponent };